<template>
  <div class="container">
    <div
      class="bg-white flex justify-between items-center w-full py-2 space-x-2"
      :class="{'drp-menu': index < answers.length - 1}"
      v-for="(answer, index) in answers"
      :key="index"
    >
      <div class="cursor-pointer break-all">
        {{answer || (lang === 'en' ? `Answer ${index+1}` : ` اجابة رقم ${index+1}`)}}
      </div>
      <div class="radio-option"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['answers', 'lang']
}
</script>

<style lang="scss" scoped>

.drp-menu {
  border-bottom: 1px solid #C2C2C2;;
}

.radio-option {
  height: 15px;
  width: 15px;
  min-width: 15px;
  opacity: 0.7;
  border: 1px solid #C2C2C2;

  @apply
    rounded-full
    opacity-50;
}
</style>
